import { ENV } from '@/globals/typescript/utils/host'

export interface IMagicAddress {
  addressLine: string
  postalCode: string
  city: string
}

// 20 real Danish addresses, one picked at random from each of 20 towns (Kolding and Ballerup
// are EFI's two sites) from OpenStreetMap's address data, which Denmark imports from the
// official DAR register, and each cross-checked in a second geocoder (2026-10-08). Street,
// number, postal code and city all exist together; there are no names, only addresses.
export const MAGIC_ADDRESSES: IMagicAddress[] = [
  { addressLine: 'Baldersgade 16', postalCode: '2200', city: 'København N' },
  { addressLine: 'Fredens Torv 5', postalCode: '8000', city: 'Aarhus C' },
  { addressLine: 'Birgittevej 10', postalCode: '5000', city: 'Odense C' },
  { addressLine: 'Brovangen 13', postalCode: '6700', city: 'Esbjerg' },
  { addressLine: 'Hobrovej 16', postalCode: '8900', city: 'Randers C' },
  { addressLine: 'Bjerggade 28', postalCode: '6000', city: 'Kolding' },
  { addressLine: 'Bjerrevej 30C', postalCode: '8700', city: 'Horsens' },
  { addressLine: 'Horsensvej 10A', postalCode: '7100', city: 'Vejle' },
  { addressLine: 'Algade 24', postalCode: '4000', city: 'Roskilde' },
  { addressLine: 'Brorsonsvej 6', postalCode: '7400', city: 'Herning' },
  { addressLine: 'Åhavevej 74', postalCode: '8600', city: 'Silkeborg' },
  { addressLine: 'Hvedevænget 99', postalCode: '4700', city: 'Næstved' },
  { addressLine: 'Bøgevej 29', postalCode: '8800', city: 'Viborg' },
  { addressLine: 'Frejasvej 46B', postalCode: '3400', city: 'Hillerød' },
  { addressLine: 'Ringgade 156', postalCode: '6400', city: 'Sønderborg' },
  { addressLine: 'Bispevangen 110', postalCode: '2750', city: 'Ballerup' },
  { addressLine: 'Brumleby 30', postalCode: '2100', city: 'København Ø' },
  { addressLine: 'Åglimt 3', postalCode: '7500', city: 'Holstebro' },
  { addressLine: 'Bjergegade 86', postalCode: '7000', city: 'Fredericia' },
  { addressLine: 'Pieren 26', postalCode: '9000', city: 'Aalborg' },
]

/**
 * The magic-address button is a dev convenience: localhost and the dev environment only.
 * Deliberately not `ENV.isDev` — that is `!isProd`, so it is also true on stage.
 */
export function canUseMagicAddress(): boolean {
  return ENV.isLocalhost || ENV.environmentName === 'dev'
}

/** A random address, never the one whose `addressLine` is already in the form. */
export function pickMagicAddress(
  currentAddressLine = '',
  random: () => number = Math.random
): IMagicAddress {
  const candidates = MAGIC_ADDRESSES.filter(
    (x) => x.addressLine !== currentAddressLine
  )
  const picked = candidates[Math.floor(random() * candidates.length)]
  return picked
    ? { ...picked }
    : { addressLine: '', postalCode: '', city: '' }
}
